export const AppTitle = 'Bosniak Classification of Cystic Renal Masses';
